export class ListItem {
  constructor(public value?: string, public text?: string, public disabled?: boolean) {}
}
